module.exports = __webpack_public_path__ + "img/Purple.1f8f82c6.png";